module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/years-list/years-list.component.scss
// module id = ./src/app/components/years-list/years-list.component.scss
// module chunks = main